// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiurl: 'https://dev-api-sp-ntl.bloomcs.com/api/',
  admin: false,
  clientId: 'f722b646-705b-42ea-9c59-c3254d607613',
  authority: 'https://login.microsoftonline.com/10eed52a-2e80-459a-9429-e971fa1da743',
  redirectUri: '/',
  protectedEndpoint: '/api',
  scope: 'api://0c00dce4-33ab-42a0-a4e0-80a45c07432d/User.Read',
  // appInsights: {
  instrumentationKey: "3f4e0567-60af-4dea-81fe-a1be84085ca2",
  // stagingInsights: "edabbd7c-d6c3-42d6-bdf9-ecbad263520a",
  // productionInsights: "6becd8a8-89b3-4d24-a53f-b55423ef0a5e",
  // }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
